import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory } from 'react-router-dom';
import {
    deleteContact,
    removeExternalContact,
} from 'flow/actions/contact-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { LocationType } from 'flow/types/Location';
import { routes } from 'flow/types/routes';
import { TypedMap } from 'flow/types/TypedMap';
import { extractName } from 'flow/utils';

interface Props {
    extensionKey?: ExtensionKey;
    contact?: TypedMap<any>;
}

const DeleteContactDialog = ({ extensionKey, contact }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory<LocationType>();

    const handleDelete = () => {
        dispatch(
            extensionKey
                ? deleteContact(extensionKey)
                : removeExternalContact(contact.get('key')),
        );

        history.push(
            history.location.state?.from
                ? history.location.state.from
                : routes['extensions'],
        );
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('Delete.User.Title')}
            onRemove={handleDelete}
        >
            {extensionKey
                ? i18next.t('Delete.User.Description')
                : i18next.t('Delete.Contact.Description', {
                      contactName: extractName(contact),
                  })}
        </BaseModal>
    );
};

export default DeleteContactDialog;
